import { imageImportSrc } from 'lib/imageImportSrc';
import opsHubChristmasLogo from 'react-scale/corp/views/CorpProjectGroupManager/views/Home/scale-holiday-logo.png';

export const HolidayScaleLogo = ({
  width = 45,
  height = 45,
  alt = 'Santa Hat with Scale Logo',
}: {
  width?: number;
  height?: number;
  alt?: string;
}) => {
  return <img src={imageImportSrc(opsHubChristmasLogo)} alt={alt} width={width} height={height} />;
};
